export default "__VITE_ASSET__SMFDHweh__"